export const environment = {
  VERSION: require('../../package.json').version,
  production: true,
  websocketUrl: 'https://a.mexico.aware.blue/',
  apiUrl: 'https://a.mexico.aware.blue/',
  apiKey: 'IDwsF4mHYL8wG7i31QaJH3cDGw8R9NZ31O0Jfw1e',
};
